<template>
  <div class="parent_container">
    <div class="add-new">
      <h2>公司简介</h2>
      <hr/>
      <p class="small-title">做有温度的移动支付产品，服务天下商家。</p>
      <br/>
      <p>广州飞鱼信息科技有限公司（简称：飞鱼科技），致力于用移动互联网、物联网的力量服务线下实体商家。飞鱼科技不仅为商家提供专业的移动支付收款工具，也为商家提供自动销售终端、智能支付终端等多元化物联网设备，助力商家拓展销售渠道，真正帮商家赚到钱，多赚钱。同时，公司还为商家提供供应链金融、广告、营销管理等多种服务。</p>
      <br/>
      <p>2017年，飞鱼科技云喇叭上线，帮助数万商家实现收款免手机播报。</p>
      <br/>
      <p>2018年，飞鱼科技云打印机上线，帮助数万商家实现外卖自动接单，收款语音播报，自助点单远程打印。</p>
      <br/>
      <p>2018年，飞鱼科技物联网统一开放平台线上设备超10万台。</p>
      <br/>
      <p>2019年，飞鱼科技聚合支付品牌付帅上线。联合持牌机构广州合利宝支付科技有限公司（目前合利宝拥有中国人民银行颁发的全业务《支付业务许可证》，业务类型包含互联网支付、移动电话支付、银行卡收单业务（覆盖全国），具有跨境人民币业务资质，是国内领先的第三方支付机构。），产品合规接入中国银联云闪付，为上万商户提供便捷安全的聚合收款服务。</p>
      <br/>
      <p> 未来十年，公司将专注物联网设备研发及其移动支付解决方案，用移动支付及物联网技术，改善人民生产生活，造福社会。</p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "fy_brief"
    }
</script>

<style scoped>
  .parent_container {
    padding: 0;
  }
  .add-new {
    padding-bottom: 1.5625rem;
  }
  .add-new h2 {
    padding: 1.0625rem 1.0625rem 0;
    font-size: 1.125rem;
  }

  .add-new .small-title {
    color: rgba(0, 102, 153, 1);
    font-size: 0.9rem;
    margin-top: 0.9375rem;
    margin-bottom: 0.4rem;
  }
  .add-new p {
    padding: 0 1.0625rem;
    font-size: 0.7rem;
    color: #333;
  }

  .add-new hr {
    margin-top: 0.5125rem;
    margin-left: 1.0625rem;
    width: 1.875rem;
    height: 0.03125rem;
    background: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/fy_brief.vue